export const TERMS_URL = 'https://www.innerhive.com/terms-of-service';

export const TOS_CONSENT_VERSION = 'tos-2026-03-16';
export const TOS_COMBINED_CONSENT_VERSION = 'tos-combined-2026-03-16';
export const SMS_CONSENT_VERSION = 'sms-2026-03-16';
export const SMS_COMBINED_CONSENT_VERSION = 'sms-combined-2026-03-16';

export const TOS_CONSENT_TEXT = 'By continuing, you agree to our Terms';

export const SMS_CONSENT_CREATE_TEXT = 'By selecting "Create account" you consent to receive texts from Innerhive, including tips, updates, and offers. Msg frequency varies; data rates may apply. Text STOP to cancel.';

export const SMS_CONSENT_CONTINUE_TEXT = 'By selecting "Continue" you consent to receive texts from Innerhive, including tips, updates, and offers. Msg frequency varies; data rates may apply. Text STOP to cancel.';

export const SMS_CONSENT_SAVE_TEXT = 'By selecting "Save" you consent to receive texts from Innerhive, including tips, updates, and offers. Msg frequency varies; data rates may apply. Text STOP to cancel.';

export const COMBINED_CONSENT_SAVE_TEXT = 'By selecting "Save" you accept our Terms and consent to receive texts from Innerhive, including tips, updates, and offers. Msg frequency varies; data rates may apply. Text STOP to cancel.';
